import SectionWrapper from '@/components/atoms/SectionWrapper';
import RequestsTable from '@/components/reports/totalRevenue/RequestsTable';
import { Stats } from '@/components/reports/totalRevenue/Stats';
import PeriodSelect from '@/components/reports/SharedComponents/PeriodSelect';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { resetTotalRevenueFilters } from '@/store/slices/reportFiltersSlice';
import { setSearch, setPage, setModalId } from '@/store/slices/publicSlice';

export default function TotalRevenue() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetTotalRevenueFilters());
      dispatch(setSearch({ key: 'revenueReportSearch', value: '' }));
      dispatch(setPage(0));
      dispatch(setModalId(null));
    };
  }, [dispatch]);

  return (
    <SectionWrapper
      title={t('reports.revenue.title', 'Platform total revenue')}
      desc={t(
        'reports.revenue.pageDesc',
        'A snapshot of the platform’s overall earnings generated from all transactions, commissions, and service fees within a selected time period.'
      )}
      actions={<PeriodSelect />}
    >
      <div className="space-y-6">
        <Stats />

        <RequestsTable />
      </div>
    </SectionWrapper>
  );
}
